export const ButtonColor = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
  WARNING: 'warning',
  TONAL: 'tonal',
  SUCCESS: 'success',
  SUCCESS_VARIANT_20: 'success-20',
  GRAY: 'gray',
  BLACK: 'black',
};

export type ButtonColor = (typeof ButtonColor)[keyof typeof ButtonColor];
